import { render, staticRenderFns } from "./recipe-ingredients.vue?vue&type=template&id=72d9978e&"
import script from "./recipe-ingredients.vue?vue&type=script&lang=js&"
export * from "./recipe-ingredients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports